$(document).ready(function(){
  
  $(".ag_header_list_1_c, .ag_header_logo_icon, .ag_header_icon").hover(
    function () {
      $(".ag_header_bg").addClass("ag_header_bg_h");
    },
    function () {
      $(".ag_header_bg").removeClass("ag_header_bg_h");
    }
  );
   $(".ag_header_bars, .ag_header_cross, .ag_header_overlay, .ag_mega_bar_cross").click(function(){
    $(".ag_header_list").toggleClass("ag_header_list_s");
    $(".ag_header_overlay").toggleClass("ag_header_overlay_s");
   
  });
  
    $(".ag_header_cross").click(function(){
       $(".ag_mega_menu").removeClass("ag_mega_menu_s");
       $(".ag_header_bg").removeClass("ag_header_bg_h");
    });
 
  if ($(window).width() < 1025) {
    $(".ag_navbar_li_mega").click(function(){
      $(this).find(".ag_navbar_li_icon").toggleClass("ag_navbar_li_icon_r");
      $(this).find(".ag_navbar_third").toggle();
    });
    $(".ag_header_list_1_js").click(function(){
      $(this).parents(".ag_header_list_1_c").find(".ag_mega_menu").addClass("ag_mega_menu_s");
    });
    $(".ag_mega_bar_prev").click(function(){
      $(this).parents(".ag_header_list_1_c").find(".ag_mega_menu").removeClass("ag_mega_menu_s");
    });
    $(".ag_header_overlay, .ag_mega_bar_cross").click(function(){
      $(".ag_mega_menu").removeClass("ag_mega_menu_s");
    });
  }
  
});
